import dayjs from 'dayjs';
import { GridColDef } from '@mui/x-data-grid';
import { Link, Tooltip, tooltipClasses, TooltipProps } from '@mui/material';
import styled from 'styled-components';
import { DATE_FORMAT } from '@constants';
import { Axios } from '@helpers';

const CustomWidthTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 500,
  },
});

const handleFileDownload = async (id: string, modelId: string) => {
  try {
    const response = await Axios.get(`/admin/models/${modelId}/model-documents/${id}/download`);
    const downloadUrl = response.data.url;

    window.open(downloadUrl, '_blank');
  } catch (error) {
    console.error('Error fetching download URL:', error);
  }
};

export const getColumns = (): GridColDef[] => [
  {
    field: 'name',
    headerName: 'Name',
    flex: 1,
    minWidth: 400,
    renderCell: ({ value, row: { id, modelId } }) => (
      <CustomWidthTooltip placement="top-start" title={value}>
        <Link
          className="ellipsis"
          component="button"
          onClick={(e) => {
            e.preventDefault();
            handleFileDownload(id, modelId);
          }}
          sx={{
            cursor: 'pointer',
            textAlign: 'left',
          }}
        >
          {value}
        </Link>
      </CustomWidthTooltip>
    ),
  },
  {
    field: 'updatedAt',
    headerName: 'Update date',
    flex: 2,
    minWidth: 170,
    renderCell: ({ row: { updatedAt } }) => dayjs(updatedAt).format(DATE_FORMAT),
  },
  {
    field: 'createdAt',
    headerName: 'Date of addition',
    flex: 2,
    minWidth: 170,
    renderCell: ({ row: { createdAt } }) => dayjs(createdAt).format(DATE_FORMAT),
  },
];
